export const close = {
	className: 'icon-close',
	viewBox: '0 0 190.95 190.89999',
	paths: ['m 118.1,95.45 68.2,-68.2 c 6.2,-6.2 6.2,-16.4 0,-22.6 -6.2,-6.2 -16.4,-6.2 -22.6,0 L 95.5,72.85 27.3,4.65 c -6.2,-6.2 -16.4,-6.2 -22.6,0 -3.1,3.1 -4.7,7.2 -4.7,11.3 0,4.1 1.6,8.2 4.7,11.3 l 68.2,68.2 -68.2,68.2 c -3.1,3.1 -4.7,7.2 -4.7,11.3 0,4.1 1.6,8.2 4.7,11.3 6.2,6.2 16.4,6.2 22.6,0 l 68.2,-68.2 68.2,68.2 c 6.2,6.2 16.4,6.2 22.6,0 6.2,-6.2 6.2,-16.4 0,-22.6 l -68.2,-68.2 z']
}
